export default "__VITE_ASSET__c0c72a94__"